<template>
  <v-dialog v-model="show" max-width="800px" scrollable>
    <v-card>
      <div v-show="isSuccessEditOrCreate === true" class="pa-5">
        <div class="succes_box">
          <v-icon size="35" color="green">check</v-icon>
          <p>Éxito al {{ isEdit ? 'editar' : 'crear' }} ajuste</p>
        </div>
      </div>
      <div v-show="errorMsg !== undefined && loading === false" class="pa-5">
        <v-icon @click="close" class="close">close</v-icon>
        <div class="error_msg">
          <v-icon color="red">warning</v-icon>
          <div>
            <span>{{ errorMsg }}</span>
          </div>
        </div>
      </div>
      <div v-show="loading === true && errorMsg === undefined" class="pa-5">
        <v-icon @click="close" class="close">close</v-icon>
        <div class="lds-dual-ring"></div>
      </div>
      <div
        v-show="
          loading === false &&
          errorMsg === undefined &&
          isSuccessEditOrCreate === false
        "
        class="main_box"
        @click="hide"
      >
        <v-icon @click="close" class="close">close</v-icon>
        <v-card-title class="modal_title pa-4">
          <v-icon color="primary" class="mr-2">settings</v-icon>
          <p class="modal_title-title">
            {{ title }}
          </p>
        </v-card-title>
        <v-card-text class="mb-3">
          <div class="custom_box px-4 py-3">
            <div class="custom_switch">
              <span class="mr-4">Recepción de reportes por correo</span>
              <v-switch color="primary" v-model="receiveReports"></v-switch>
            </div>
            <p class="email_text">Correo electrónico</p>
            <div class="custom_box-middle">
              <div class="box1">
                <input
                  type="email"
                  v-model="newEmail"
                  @keyup.enter="addEmailFromForm"
                />
                <p class="email_warning" v-show="showEmailWarning">
                  El correo es inválido
                </p>
              </div>
              <div class="box2">
                <button @click="addEmailFromForm">
                  <v-icon size="35" color="black">add</v-icon>
                </button>
              </div>
              <div class="box3">
                <div class="list_emails">
                  <ul>
                    <li v-for="email in emails" close :key="email.id">
                      <v-chip class="mr-4">
                        <input
                          v-if="email.focus"
                          type="email"
                          v-model="email.text"
                          @keyup.enter="focusEmail($event, email)"
                        />
                        <span v-else>{{ email.text }}</span>
                        <v-icon
                          size="20"
                          class="mx-1"
                          color="black"
                          @click="focusEmail($event, email)"
                        >
                          edit
                        </v-icon>
                        <v-icon
                          size="20"
                          class="mx-1"
                          color="black"
                          @click="removeEmail(email)"
                        >
                          cancel
                        </v-icon>
                      </v-chip>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="box4">
                <p class="mb-1">Periodicidad</p>
                <div class="custom_drop" ref="host_box">
                  <div class="selected_drop" @click="hideDrop = false">
                    <span class="px-3 py-2">
                      {{ selectedPeriod.text }}
                    </span>
                    <v-icon color="black"> arrow_drop_down </v-icon>
                  </div>
                  <ul :class="['drop', hideDrop ? 'hide' : '']">
                    <li
                      v-for="(period, i) in possiblePeriods"
                      :key="period.value"
                    >
                      <button
                        :class="[
                          'ml-3',
                          'period',
                          period.isSelected ? 'selected' : '',
                        ]"
                        @click="selectPeriod(period)"
                      >
                        {{ period.text }}
                      </button>
                      <v-divider
                        v-if="i !== possiblePeriods.length - 1"
                      ></v-divider>
                    </li>
                  </ul>
                </div>
                <!-- <v-select
                  class="custom_select"
                  height="20"
                  solo
                  flat
                  label="Periodicidad"
                  item-text="text"
                  item-value="value"
                  hide-details
                  :items="items"
                  v-model="selectedPeriod"
                ></v-select> -->
              </div>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn flat @click="close" class="modal_button"> Cancelar </v-btn>
          <v-btn flat @click="submit" class="modal_button"> Guardar </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
class Email {
  /**
   *
   * @param {{id?:string|number,text?:string, focus?:boolean} } params
   */
  constructor(params = {}) {
    this.id = params.id
    this.text = params.text
    this.focus = params.focus
  }
}

export default {
  props: {
    reportSettingtype: String,
    show: Boolean,
    title: String,
  },
  data: () => ({
    showEmailWarning: false,
    isSuccessEditOrCreate: false,
    isEdit: false,
    idRequest: 0,
    loading: false,
    errorMsg: undefined,
    show: false,
    selectedPeriod: undefined,
    hideDrop: true,
    receiveReports: false,
    newEmail: '',
    /**
     * @type {Array<Email>}
     */
    emails: [],
    possiblePeriods: [
      { text: 'Diario', value: 'DAILY', isSelected: false },
      { text: 'Semanal', value: 'WEEKLY', isSelected: false },
      { text: 'Mensual', value: 'MONTHLY', isSelected: false },
    ],
  }),
  beforeMount() {
    if (this.selectedPeriod === undefined) {
      this.selectPeriod(this.possiblePeriods.at(0))
    }
  },
  methods: {
    async _initialState() {
      this.show = false
      await this._sleep(300)
      this.isSuccessEditOrCreate = false
      this.showEmailWarning = false
      this.isEdit = false
      this.errorMsg = undefined
      this.loading = false
      this.emails = []
      this.hideDrop = true
      this.receiveReports = false
      this.newEmail = ''
      this.title = 'Configuración de reporte'
      this.selectPeriod(this.possiblePeriods.at(0))
    },
    addEmailFromForm() {
      if (this.newEmail === '' || this.showEmailWarning === true) return
      this.emails.push(
        new Email({
          text: this.newEmail,
          focus: false,
          id: Math.random().toString(),
        })
      )
      this.newEmail = ''
    },
    generateEmail(email) {
      return new Email({
        text: email,
        focus: false,
        id: Math.random().toString(),
      })
    },
    removeEmail(email) {
      this.emails = this.emails.filter((e) => e.id !== email.id)
    },
    async focusEmail(e, email) {
      e.stopPropagation()
      if (email.focus === true) {
        email.focus = false
        return
      }

      for (const email of this.emails) {
        email.focus = false
      }

      email.focus = true
      await this._sleep(50)
      e.target.previousElementSibling.focus()
    },
    selectPeriod(period) {
      this.selectedPeriod = period

      for (const period of this.possiblePeriods) {
        period.isSelected = false
      }

      period.isSelected = true
      this.hideDrop = true
    },
    _sleep(timeInms = 300) {
      return new Promise((res, _) => {
        const y = setTimeout(() => {
          res()
          clearTimeout(y)
        }, timeInms)
      })
    },
    async submit() {
      const isSuccess = await this._callApi()
      await this._sleep(500)
      if (isSuccess) {
        this.closeModal()
      }
    },
    close() {
      this.closeModal()
    },
    closeModal() {
      this.$emit('closeEditSetting', undefined)
    },
    _childOf(childNode, parentNode) {
      while ((childNode = childNode.parentNode) && childNode !== parentNode);
      return !!childNode
    },
    hide() {
      if (this.hideDrop) return
      if (this._childOf(event.target, this.$refs.host_box)) return
      this.hideDrop = true
    },
    _callApi() {
      if (this.isEdit === true) {
        return this._editReportSettings()
      } else {
        return this._createReportSettings()
      }
    },
    async _createReportSettings() {
      const data = {
        emails: this.emails.map((e) => e.text),
        periodicity: this.selectedPeriod.value,
        type: this.reportSettingtype,
      }

      try {
        this.loading = true
        await this.$store.dispatch('reports/createReportSettings', data)
        this.isSuccessEditOrCreate = true
        this.loading = false
        return true
      } catch (error) {
        console.log(error)
        this.loading = false
        if (error.response.status === 400) {
          this.errorMsg = 'Ya existe una configuración'
          return
        }

        if (error.response.status === 404) {
          this.errorMsg = 'Usuario inválido'
          return
        }

        this.errorMsg = 'Error al crear ajuste de reporte'
      }
    },
    async _editReportSettings() {
      const data = {
        emails: this.emails.map((e) => e.text),
        periodicity: this.selectedPeriod.value,
        type: this.reportSettingtype,
        enabled: this.receiveReports,
      }

      try {
        this.loading = true
        await this.$store.dispatch('reports/editReportSettings', data)
        this.isSuccessEditOrCreate = true
        this.loading = false
        return true
      } catch (error) {
        console.log(error)
        this.loading = false
        if (error.response.status === 404) {
          this.errorMsg = 'Error 404 tipo de reporte no existentente'
          return
        }

        this.errorMsg = 'Error al editar ajuste de reporte'
      }
    },
    /**
     *
     * @param {number} idReq
     * @param {'ENTRY_DEPARTURE'|'COLLABORATOR_ASSISTANCE'|'STUDENT_DELIVERY'|'STUDENT_ASSISTANCE'} reportSettingtype
     */
    _getReportSettings(idReq, reportSettingtype) {
      const possibleTypes = [
        'ENTRY_DEPARTURE',
        'COLLABORATOR_ASSISTANCE',
        'STUDENT_DELIVERY',
        'STUDENT_ASSISTANCE',
      ]

      if (possibleTypes.includes(reportSettingtype) === false) {
        this.errorMsg = 'Error al buscar el tipo de reporte'
        console.error('Type not foud')
        return
      }

      const param = {
        type: reportSettingtype,
      }
      this.loading = true
      this.$store
        .dispatch('reports/getReportSettings', param)
        .then((response) => {
          if (this.idRequest !== idReq) return

          this.selectPeriod(
            this.possiblePeriods.find(
              (e) => e.value === response.data.periodicity
            )
          )
          this.receiveReports = response.data.enabled
          this.emails = response.data.recipients.map((e) =>
            this.generateEmail(e)
          )
          this.isEdit = true
          this.loading = false
        })
        .catch((error) => {
          if (this.idRequest !== idReq) return

          if (error.response.status !== 404) {
            console.log(error)
            this.errorMsg = 'Error al solicitar datos'
            this.isEdit = true
            this.loading = false
            return
          }

          this.isEdit = false
          this.loading = false
        })
    },
  },
  watch: {
    newEmail() {
      if (this.newEmail === '') {
        this.showEmailWarning = false
        return
      }

      const regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)
      const isValidEmail = regexEmail.test(this.newEmail)
      this.showEmailWarning = isValidEmail === false
    },
    show() {
      if (this.show === false) {
        this._initialState()
        this.close()
        this.idRequest = Math.random()
      }
      if (this.show === true) {
        this._getReportSettings(this.idRequest, this.reportSettingtype)
      }
    },
  },
}
</script>

<style scoped>
/* override css */
::v-deep .v-input.custom_select.v-text-field.v-text-field--enclosed {
  border: 1px solid red;
  border-radius: 6px;
  padding: 1px;
}
::v-deep .v-input--selection-controls {
  margin: 0;
  padding: 0;
}
::v-deep .v-btn__content {
  text-transform: initial !important;
}
::v-deep
  .v-input--selection-controls:not(.v-input--hide-details)
  .v-input__slot {
  margin: 0;
}
.email_warning {
  font-size: 16px;
  font-weight: 500;
  color: red;
}
.succes_box {
  font-size: 20px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.error_msg {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.main_box {
  position: relative;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
}

.modal_title {
  display: flex;
  align-items: center;
}

.modal_title-title {
  margin: 0;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
}

.modal_button {
  margin: 0;
  width: 100px;
  border-radius: 8px;
  border: 1px solid #cccc;
  color: #272727;
  text-transform: capitalize;
}
.custom_box {
  border: 1px solid var(--gray-200, #e5e7eb);
  border-radius: 6px;
}
.custom_box-content {
  padding: 0 70px;
}
.custom_switch {
  display: flex;
  justify-content: start;
}
.custom_switch span {
  color: var(--gray-700, #374151);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.email_text {
  margin: 0;
}
.custom_box-middle {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 5px;
  grid-auto-rows: minmax(100px, auto);
}
.box1 {
  grid-column: 1 / 6;
  grid-row: 1;
}
.box1 input {
  padding: 7px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--gray-300, #d1d5db);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}
ul,
li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.box2 {
  display: grid;
  grid-column: 6 / 7;
  grid-row: 1;
  justify-content: center;
  align-content: baseline;
}
.box3 {
  grid-column: 7 / 13;
  grid-row: 1/3;
}
.list_emails {
  height: 200px;
  overflow: scroll;
  border-radius: 6px;
  border: 1px solid var(--gray-200, #e5e7eb);
}
.box4 {
  grid-column: 1 / 6;
  grid-row: 2;
}

.custom_drop {
  position: relative;
}
.selected_drop {
  cursor: pointer;
  margin: 0;
  min-height: 15px;
  border: 1px solid var(--gray-300, #d1d5db);
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
}
.period {
  color: var(--gray-500, #6b7280);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  height: 30px;
  width: 100%;
  text-align: left;
}
.drop {
  cursor: pointer;
  position: absolute;
  z-index: 2;
  background-color: white;
  border: 1px solid var(--gray-300, #d1d5db);
  border-radius: 6px;
  width: 100%;
  top: 0;
  color: var(--gray-500, #6b7280);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.hide {
  display: none;
}
.selected {
  color: red;
}

.lds-dual-ring {
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
}
.lds-dual-ring:after {
  content: ' ';
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #ef565b;
  border-color: #ef565b transparent #ef565b transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes ws_new_entry_bg_color {
  from {
    box-shadow: rgb(247, 0, 0) 0px 30px 60px -12px inset,
      rgb(255, 0, 0) 0px 18px 36px -18px inset;
  }
  to {
    box-shadow: transparent;
  }
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
